import { useAuth0 } from '@auth0/auth0-react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectUser, selectIsVideoClient, selectIsAllowedShotsPlayer, selectIsAllowedReportGeneration, selectIsAllowedDoublesPlayer } from '../features/auth/authSlice';
import PathConstants from '../routes/pathConstants';

function FeatureCard({ to, icon, title, description }) {
    return (
        <div className="col-md-4 col-sm-6 mb-4">
            <Link to={to} className="text-decoration-none">
                <div className="card h-100 shadow-sm" style={{ cursor: 'pointer', transition: 'transform 0.2s' }}
                    onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-4px)'}
                    onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}>
                    <div className="card-body text-center p-4">
                        <div className="mb-3">
                            <i className={`${icon} fs-3`} style={{ fontSize: '2rem', color: '#b8860b' }}></i>
                        </div>
                        <h5 className="card-title">{title}</h5>
                        <p className="card-text text-muted">{description}</p>
                    </div>
                </div>
            </Link>
        </div>
    );
}

function IndexPage() {
    const { isAuthenticated, isLoading } = useAuth0();
    const userInfo = useSelector(selectUser);
    const isVideoClient = useSelector(selectIsVideoClient);
    const isAllowedShotsPlayer = useSelector(selectIsAllowedShotsPlayer);
    const isAllowedReportGeneration = useSelector(selectIsAllowedReportGeneration);
    const isAllowedDoublesPlayer = useSelector(selectIsAllowedDoublesPlayer);

    if (isLoading) {
        return <div>Loading...</div>;
    }

    const features = [];

    if (isVideoClient && isAllowedShotsPlayer) {
        features.push(
            { to: PathConstants.SHOTSVIEW, icon: 'fas fa-video', title: 'Shots & Clips', description: 'View match shots and create custom video clips' },
        );
    }

    if (isAllowedDoublesPlayer) {
        features.push(
            { to: PathConstants.DOUBLES, icon: 'fas fa-users', title: 'Doubles Player', description: 'Analyze doubles match footage' },
        );
    }

    if (isVideoClient && isAllowedReportGeneration) {
        features.push(
            { to: PathConstants.REPORTGENERATION, icon: 'fas fa-chart-bar', title: 'Report Generation', description: 'Generate performance and analytics reports' },
        );
    }

    return (
        <div>
            {isAuthenticated && userInfo && (
                <div>
                    <h4 className="mb-4">
                        Welcome, {userInfo.name || userInfo.email || userInfo.preferred_username}!
                    </h4>
                    {features.length > 0 ? (
                        <div className="row">
                            {features.map((feature) => (
                                <FeatureCard key={feature.to} {...feature} />
                            ))}
                        </div>
                    ) : (
                        <p className="text-muted">No features are currently enabled for your account. Please contact support if you believe this is an error.</p>
                    )}
                </div>
            )}
        </div>
    );
}

export default IndexPage;
